<div class="chip-filter">
    <div *ngFor="let item of items; index as idx">
        <chip [Label]="item.Label" [Type]="ChipType" (onClick)="filterChip(item, $event, idx)" [Selected]="selectedIndex === idx"></chip>
    </div>
</div>